import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const LicensesTableHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <>
      <thead className="table-light">
        <tr>
          <th className="text-left">{t('Name')}</th>
          <th className="text-left">{t('Date')}</th>
          <th className="text-center" />
        </tr>
      </thead>
    </>
  );
};

export default LicensesTableHeader;
